import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { encrypt, getDataFromLocalStorage, getUserType } from 'utils/helpers';
import { setIsCollapseSidebar, setIsLogout } from 'store/slices';
import {
  adminRoute,
  corporateRoute,
  institutionalRoute,
  profetionalRoute,
  resourceRoute,
  studentRoute,
  icons,
  reportSubMenu,
  accountsRoute,
  superAdminRoute,
  raisedRequestSubMenu,
  requestReceivedSubMenu,
  trackingSubMenu,
  notificationSubMenu,
  RESEARCHPEDIA_BASE_URL,
} from 'utils/constants';
import './Sidebar.scss';
import { useEffect } from 'react';

const Sidebar = () => {
  const params = useParams();
  const dispatch = useDispatch();

  const { userDetails } = useSelector((state) => ({
    userDetails: state.student.userDetails,
  }));

  const filterDigitalLibraryAccess = (options) => {
    const email = getDataFromLocalStorage('email_id');

    return options.filter((option) => {
      if (option.title === 'IFERP Digital Library') {
        return userDetails?.researchpedia_status === true;
      }
      return true;
    });
  };

  const adminSidebarOptions = [
    {
      id: 1,
      title: 'Dashboard',
      icon: icons.NewDashboard,
      url: adminRoute.dashboard,
    },

    {
      id: 2,
      title: 'Profile Management',
      icon: icons.NewProfile,
      url: adminRoute.profileManagement,
    },

    {
      id: 3,
      title: 'Event Management',
      icon: icons.NewConferences,
      url: adminRoute.eventManagement,
    },
    {
      id: 4,
      title: 'Raised Request',
      icon: icons.NewRaisedRequestIcon,
      url: adminRoute.raisedRequest,
      permissionKey: 'Requests',
    },
    {
      id: 5,
      title: 'Request Received',
      icon: icons.NewRaisedRequestIcon,
      url: adminRoute.requestReceived,
      permissionKey: 'Requests',
    },
    {
      id: 6,
      title: 'Tracking',
      icon: icons.NewRaisedRequestIcon,
      url: adminRoute.tracking,
      permissionKey: 'Tracking',
    },

    // {
    //   id: 7,
    //   title: 'Segment',
    //   icon: icons.NewConferences,
    //   url: adminRoute.segmentManagement,
    // },
    // {
    //   id: 8,
    //   title: 'Follow-Up & Discount',
    //   icon: icons.NewConferences,
    //   url: adminRoute.followUpAndDiscount,
    // },
    {
      id: 9,
      title: 'Journal Management',
      icon: icons.NewPublications,
      url: adminRoute.journalManagement,
    },
    {
      id: 10,
      title: 'Network Management',
      icon: icons.NewNetworks,
      url: adminRoute.networkManagement,
    },
    {
      id: 11,
      title: 'Chapters & Groups Management',
      icon: icons.NewGroups,
      url: adminRoute.chaptersAndGroups,
    },
    {
      id: 12,
      title: 'Certificate Management',
      icon: icons.NewCertificate,
      url: adminRoute.certificateManagement,
    },
    {
      id: 13,
      title: 'Award Management',
      icon: icons.NewNomiAward,
      url: adminRoute.awardManagement,
    },
    {
      id: 14,
      title: 'Resource Management',
      icon: icons.NewGroups,
      url: adminRoute.resourceManagement,
    },
    {
      id: 15,
      title: 'Account Management',
      icon: icons.NewGroups,
      url: adminRoute.accountManagement,
    },
    {
      id: 16,
      title: 'Payment Verification',
      icon: icons.NewGroups,
      url: adminRoute.paymentVerification,
    },

    {
      id: 17,
      title: 'Career Management',
      icon: icons.NewCareers,
      url: adminRoute.careerManagement,
    },
    {
      id: 18,
      title: 'Mentorship Management',
      icon: icons.NewMentorship,
      url: adminRoute.mentorshipManagement,
    },
    {
      id: 19,
      title: 'Inbox/Notifications',
      icon: icons.NewInbox,
      url: adminRoute.inboxNotifications,
    },
    {
      id: 20,
      title: 'Reports',
      icon: icons.NewInbox,
      url: adminRoute.reports,
    },
    {
      id: 21,
      title: 'Branding Management',
      icon: icons.NewCertificate,
      url: adminRoute.brandingManagement,
    },
    {
      id: 22,
      title: 'University Management',
      icon: icons.NewConferences,
      url: adminRoute.universityManagement,
    },
    {
      id: 23,
      title: 'Institution Management',
      icon: icons.NewConferences,
      url: adminRoute.institutionManagement,
    },
    {
      id: 24,
      title: 'Region Management',
      icon: icons.NewGroups,
      url: adminRoute.regionManagement,
    },
    {
      id: 25,
      title: 'Department Management',
      icon: icons.NewGroups,
      url: adminRoute.departmentManagement,
    },
    {
      id: 26,
      title: 'Settings',
      icon: icons.NewCareers,
      url: adminRoute.setting,
    },
    {
      id: 27,
      title: 'Newsletter',
      icon: icons.NewGroups,
      url: adminRoute.newsLetter,
    },
    {
      id: 28,
      title: 'Instant Ticket Generate',
      icon: icons.QRScanner,
      url: adminRoute.instantTicketGenerate,
    },
    {
      id: 29,
      title: 'Email Templates',
      icon: icons.Email,
      url: adminRoute.emailTemplates,
    },
    // {
    //   id: 29,
    //   title: "User Activity Management",
    //   icon: icons.NewProfile,
    //   url: adminRoute.userActivityManagement,
    // },
  ];

  const filteredAdminSidebarOptions = adminSidebarOptions.filter((option) => {
    if (option.title === 'Dashboard' || option.title === 'Account Management') {
      return true;
    }
    const permission = userDetails?.role_data?.find(
      (item) =>
        item.permission_name === option.title ||
        item.permission_name === option.permissionKey,
    );
    return permission?.sub_permission?.view === '1';
  });

  const studentSidebarOptions = [
    {
      id: 1,
      title: 'Dashboard',
      icon: icons.NewDashboard,
      url: studentRoute.dashboard,
    },
    {
      id: 2,
      title: 'My Profile',
      icon: icons.NewProfile,
      url: `${studentRoute.myProfile}/research-profile`,
      tourId: 'profile-details-id',
    },
    {
      id: 3,
      title: 'Conferences & Events',
      icon: icons.NewConferences,
      url: `${studentRoute.conferencesAndEvents}/iferp-events/event-list/conference`,
      tourId: 'all-events-id',
    },
    {
      id: 4,
      title: 'Publications',
      icon: icons.NewPublications,
      url: `${studentRoute.publications}/scopus-indexed-journals`,
      tourId: 'publications-id',
    },
    {
      id: 5,
      title: 'Inbox/Notifications',
      icon: icons.NewInbox,
      url: `${studentRoute.inboxNotifications}/inbox`,
    },
    {
      id: 6,
      title: 'My Post and Networks',
      icon: icons.NewNetworks,
      url: `${studentRoute.networkManagement}/posts/discover-posts`,
      tourId: 'my-network-community-id',
    },
    {
      id: 7,
      title: 'Chapters & Groups',
      icon: icons.NewGroups,
      url: `${studentRoute.chaptersAndGroups}/chapters`,
      tourId: 'chapters-groups-id',
    },
    {
      id: 8,
      title: 'Career Support',
      icon: icons.NewCareers,
      url: `${studentRoute.careerSupport}/careers`,
      tourId: 'career-support-id',
    },
    {
      id: 9,
      title: 'Mentorship',
      icon: icons.NewMentorship,
      url: studentRoute.mentorship,
      tourId: 'mentorship-id',
      isNewFeature: true,
    },
    {
      id: 10,
      title: 'Nominate For Award',
      icon: icons.NewNomiAward,
      url: studentRoute.nominateForAward,
      tourId: 'nomiante-for-awards-id',
    },
    {
      id: 11,
      title: 'IFERP Digital Library',
      icon: icons.NewDigitalLibrary,
      url: studentRoute.digitalLibrary,
    },
    {
      id: 12,
      title: 'Certificates & Rewards',
      icon: icons.NewCertificate,
      url: studentRoute.certificatesAndRewards,
    },
    {
      id: 13,
      title: 'Award Winners',
      icon: icons.NewNomiAward,
      url: studentRoute.awardWinners,
    },
    {
      id: 14,
      title: 'Help & support',
      icon: icons.NewHelp,
      url: studentRoute.helpSupport,
    },
  ];

  const profetionalSidebarOptions = [
    {
      id: 1,
      title: 'Dashboard',
      icon: icons.NewDashboard,
      url: profetionalRoute.dashboard,
    },

    {
      id: 15,
      title: 'My Task',
      icon: icons.NewPublications,
      url: profetionalRoute.myTask,
      tourId: 'my-task-id',
    },
    {
      id: 2,
      title: 'My Profile',
      icon: icons.NewProfile,
      url: `${profetionalRoute.myProfile}/research-profile`,
      tourId: 'profile-details-id',
    },
    {
      id: 3,
      title: 'Conferences & Events',
      icon: icons.NewConferences,
      url: `${profetionalRoute.conferencesAndEvents}/iferp-events/event-list/conference`,
      tourId: 'all-events-id',
    },
    {
      id: 4,
      title: 'Publications',
      icon: icons.NewPublications,
      url: `${profetionalRoute.publications}/scopus-indexed-journals`,
      tourId: 'publications-id',
    },
    {
      id: 5,
      title: 'Inbox/Notifications',
      icon: icons.NewInbox,
      url: `${profetionalRoute.inboxNotifications}/inbox`,
    },
    {
      id: 6,
      title: 'My Post and Networks',
      icon: icons.NewNetworks,
      url: `${profetionalRoute.networkManagement}/posts/discover-posts`,
      tourId: 'my-network-community-id',
    },
    {
      id: 7,
      title: 'Chapters & Groups',
      icon: icons.NewGroups,
      url: `${profetionalRoute.chaptersAndGroups}/chapters`,
      tourId: 'chapters-groups-id',
    },
    {
      id: 8,
      title: 'Career Support',
      icon: icons.NewCareers,
      url: `${profetionalRoute.careerSupport}/careers`,
      tourId: 'career-support-id',
    },
    {
      id: 9,
      title: 'Mentorship',
      icon: icons.NewMentorship,
      url: profetionalRoute.mentorship,
      tourId: 'mentorship-id',
      isNewFeature: true,
    },
    {
      id: 10,
      title: 'Nominate For Award',
      icon: icons.NewNomiAward,
      url: profetionalRoute.nominateForAward,
      tourId: 'nomiante-for-awards-id',
    },
    {
      id: 11,
      title: 'IFERP Digital Library',
      icon: icons.NewDigitalLibrary,
      url: profetionalRoute.digitalLibrary,
    },
    {
      id: 12,
      title: 'Certificates & Rewards',
      icon: icons.NewCertificate,
      url: profetionalRoute.certificatesAndRewards,
    },
    {
      id: 13,
      title: 'Award Winners',
      icon: icons.NewNomiAward,
      url: profetionalRoute.awardWinners,
    },
    {
      id: 14,
      title: 'Help & support',
      icon: icons.NewHelp,
      url: profetionalRoute.helpSupport,
    },
  ];

  const instituteSidebarOptions = [
    {
      id: 1,
      title: 'Dashboard',
      icon: icons.NewDashboard,
      url: institutionalRoute.dashboard,
    },
    {
      id: 2,
      title: 'Our Profile',
      icon: icons.NewProfile,
      url: `${institutionalRoute.myProfile}/my-membership`,
    },
    {
      id: 3,
      title: 'Activity Plan',
      icon: icons.activePlan,
      url: `${institutionalRoute.activityPlan}/iferp-plan`,
    },
    {
      id: 4,
      title: 'Our Academicians',
      icon: icons.ourAcademies,
      url: `${institutionalRoute.ourAcademies}/student-members`,
    },
    {
      id: 5,
      title: 'Conferences & Events',
      icon: icons.NewConferences,
      url: `${institutionalRoute.conferencesAndEvents}/iferp-events/event-list/conference`,
    },
    {
      id: 6,
      title: 'Publications',
      icon: icons.NewPublications,
      url: `${institutionalRoute.publications}/scopus-indexed-journals`,
    },
    {
      id: 7,
      title: 'Inbox/Notifications',
      icon: icons.NewInbox,
      url: `${institutionalRoute.inboxNotifications}/inbox`,
    },
    {
      id: 8,
      title: 'My Post and Networks',
      icon: icons.NewNetworks,
      url: `${institutionalRoute.networkManagement}/posts/discover-posts`,
    },
    {
      id: 9,
      title: 'Innovation Ambassador',
      icon: icons.innovation,
      url: `${institutionalRoute.innovationAmbassador}/student-ambassadors`,
    },
    {
      id: 10,
      title: 'Chapters & Groups',
      icon: icons.NewGroups,
      url: `${institutionalRoute.chaptersAndGroups}/chapters`,
    },
    {
      id: 11,
      title: 'Career Support',
      icon: icons.NewCareers,
      url: `${institutionalRoute.careerSupport}/careers`,
    },
    {
      id: 12,
      title: 'Nominate For Award',
      icon: icons.nominateAward,
      url: institutionalRoute.nominateForAward,
    },
    {
      id: 13,
      title: 'IFERP Digital Library',
      icon: icons.NewDigitalLibrary,
      url: corporateRoute.digitalLibrary,
    },
    {
      id: 14,
      title: 'Certificates & Rewards',
      icon: icons.NewCertificate,
      url: institutionalRoute.certificatesAndRewardsList,
    },
    {
      id: 15,
      title: 'Collaboration',
      icon: icons.collaboration,
      url: institutionalRoute.collaboration,
    },
    {
      id: 16,
      title: 'Funds And Grants',
      icon: icons.fund,
      url: `${institutionalRoute.fundsAndGrants}/accepted-proposals`,
    },
    {
      id: 17,
      title: 'Help',
      icon: icons.NewHelp,
      url: institutionalRoute.helpSupport,
    },
  ];

  const corporateSidebarOptions = [
    {
      id: 1,
      title: 'Dashboard',
      icon: icons.NewDashboard,
      url: corporateRoute.dashboard,
    },
    {
      id: 2,
      title: 'Our Profile',
      icon: icons.corporateProfile,
      url: `${corporateRoute.myProfile}/my-membership`,
    },
    {
      id: 3,
      title: 'Conferences & Events',
      icon: icons.NewConferences,
      url: `${corporateRoute.events}/event-list/conference`,
      tourId: 'all-events-id',
    },
    {
      id: 4,
      title: 'Publications',
      icon: icons.NewPublications,
      url: `${corporateRoute.publications}/scopus-indexed-journals`,
    },
    {
      id: 5,
      title: 'Branding & Publicity',
      icon: icons.branding,
      url: corporateRoute.brandingAndPublicity,
    },
    {
      id: 6,
      title: 'Inbox/Notifications',
      icon: icons.NewInbox,
      url: `${corporateRoute.inboxNotifications}/inbox`,
    },
    {
      id: 7,
      title: 'My Post and Networks',
      icon: icons.NewNetworks,
      url: `${corporateRoute.networkManagement}/posts/discover-posts`,
    },
    {
      id: 8,
      title: 'Chapters & Groups',
      icon: icons.NewGroups,
      url: `${corporateRoute.chaptersAndGroups}/chapters`,
    },
    {
      id: 9,
      title: 'Talent Development',
      icon: icons.NewCareers,
      url: `${corporateRoute.careerSupport}/careers`,
    },
    {
      id: 10,
      title: 'Certificates & Rewards',
      icon: icons.NewCertificate,
      url: corporateRoute.certificatesAndRewardsList,
    },
    {
      id: 11,
      title: 'Award Winners',
      icon: icons.NewNomiAward,
      url: corporateRoute.awardWinners,
    },
    {
      id: 12,
      title: 'Nominate For Award',
      icon: icons.nominateAward,
      url: corporateRoute.nominateForAward,
    },
    {
      id: 13,
      title: 'IFERP Digital Library',
      icon: icons.NewDigitalLibrary,
      url: corporateRoute.digitalLibrary,
    },
    {
      id: 14,
      title: 'Help',
      icon: icons.institutionalHelp,
      url: corporateRoute.helpSupport,
    },
  ];

  const resourceSidebarOptions = [
    {
      id: 1,
      title: 'Dashboard',
      icon: icons.NewDashboard,
      url: resourceRoute.dashboard,
    },
    {
      id: 2,
      title: 'Profile Management',
      icon: icons.NewProfile,
      url: resourceRoute.profileManagement,
    },
    {
      id: 3,
      title: 'Event Management',
      icon: icons.NewConferences,
      url: resourceRoute.eventManagement,
    },
    {
      id: 4,
      title: 'Raised Request',
      icon: icons.NewRaisedRequestIcon,
      url: resourceRoute.raisedRequest,
      permissionKey: 'Requests',
    },
    {
      id: 5,
      title: 'Tracking',
      icon: icons.NewRaisedRequestIcon,
      url: resourceRoute.tracking,
      permissionKey: 'Tracking',
    },
    // {
    //   id: 6,
    //   title: 'Segment',
    //   icon: icons.NewConferences,
    //   url: resourceRoute.segmentManagement,
    // },
    {
      id: 7,
      title: 'Journal Management',
      icon: icons.NewPublications,
      url: resourceRoute.journalManagement,
    },
    {
      id: 8,
      title: 'Chapters & Groups Management',
      icon: icons.NewGroups,
      url: resourceRoute.chaptersAndGroups,
    },
    {
      id: 9,
      title: 'My Post and Networks',
      icon: icons.NewNetworks,
      url: resourceRoute.networkManagement,
    },

    {
      id: 10,
      title: 'Certificate Management',
      icon: icons.NewCertificate,
      url: resourceRoute.certificateManagement,
    },
    {
      id: 11,
      title: 'Award Management',
      icon: icons.NewNomiAward,
      url: resourceRoute.awardManagement,
    },
    {
      id: 12,
      title: 'Resource Management',
      icon: icons.NewGroups,
      url: resourceRoute.resourceManagement,
    },
    {
      id: 13,
      title: 'Payment Verification',
      icon: icons.NewGroups,
      url: resourceRoute.paymentVerification,
    },
    {
      id: 14,
      title: 'Career Management',
      icon: icons.NewCareers,
      url: resourceRoute.careerManagement,
    },
    {
      id: 15,
      title: 'Mentorship Management',
      icon: icons.NewMentorship,
      url: resourceRoute.mentorshipManagement,
    },
    {
      id: 16,
      title: 'Inbox/Notifications',
      icon: icons.NewInbox,
      url: resourceRoute.inboxNotifications,
    },
    {
      id: 17,
      title: 'Reports',
      icon: icons.NewInbox,
      url: resourceRoute.reports,
    },
    {
      id: 18,
      title: 'Branding Management',
      icon: icons.NewCertificate,
      url: resourceRoute.brandingManagement,
    },
    {
      id: 19,
      title: 'University Management',
      icon: icons.NewConferences,
      url: resourceRoute.universityManagement,
    },
    {
      id: 20,
      title: 'Institution Management',
      icon: icons.NewConferences,
      url: resourceRoute.institutionManagement,
    },
    {
      id: 21,
      title: 'Region Management',
      icon: icons.NewGroups,
      url: resourceRoute.regionManagement,
    },
    {
      id: 22,
      title: 'Department Management',
      icon: icons.NewGroups,
      url: resourceRoute.departmentManagement,
    },
    {
      id: 23,
      title: 'Settings',
      icon: icons.NewCareers,
      url: resourceRoute.setting,
    },
    {
      id: 24,
      title: 'Newsletter',
      icon: icons.NewGroups,
      url: resourceRoute.newsLetter,
    },
    {
      id: 25,
      title: 'Instant Ticket Generate',
      icon: icons.QRScanner,
      url: resourceRoute.instantTicketGenerate,
    },
  ];

  const filtereCoOrdinatorResourceSidebarOptions =
    resourceSidebarOptions.filter((option) => {
      if (option.title === 'Dashboard') {
        return true;
      }
      const permission = userDetails?.role_data?.find(
        (item) =>
          item.permission_name === option.title ||
          item.permission_name === option.permissionKey,
      );
      return permission?.sub_permission?.view === '1';
    });

  const accountsSidebarOptions = [
    // {
    //   id: 1,
    //   title: "Accounts Management",
    //   icon: icons.NewPublications,
    //   url: accountsRoute.accountManagement,
    // },
    // {
    //   id: 2,
    //   title: "Payment Verification",
    //   icon: icons.NewPublications,
    //   url: accountsRoute.paymentVerification,
    // },
    {
      id: 1,
      title: 'Dashboard',
      icon: icons.NewDashboard,
      url: accountsRoute.dashboard,
    },
    {
      id: 2,
      title: 'Profile Management',
      icon: icons.NewProfile,
      url: accountsRoute.profileManagement,
    },
    {
      id: 3,
      title: 'Event Management',
      icon: icons.NewConferences,
      url: accountsRoute.eventManagement,
    },
    // {
    //   id: 4,
    //   title: 'Segment',
    //   icon: icons.NewConferences,
    //   url: accountsRoute.segmentManagement,
    // },
    {
      id: 5,
      title: 'Journal Management',
      icon: icons.NewPublications,
      url: accountsRoute.journalManagement,
    },
    {
      id: 6,
      title: 'Chapters & Groups Management',
      icon: icons.NewGroups,
      url: accountsRoute.chaptersAndGroups,
    },
    {
      id: 7,
      title: 'My Post and Networks',
      icon: icons.NewNetworks,
      url: accountsRoute.networkManagement,
    },

    {
      id: 8,
      title: 'Certificate Management',
      icon: icons.NewCertificate,
      url: accountsRoute.certificateManagement,
    },
    {
      id: 9,
      title: 'Award Management',
      icon: icons.NewNomiAward,
      url: accountsRoute.awardManagement,
    },
    {
      id: 10,
      title: 'Resource Management',
      icon: icons.NewGroups,
      url: accountsRoute.resourceManagement,
    },
    {
      id: 11,
      title: 'Payment Verification',
      icon: icons.NewGroups,
      url: accountsRoute.paymentVerification,
    },
    {
      id: 12,
      title: 'Career Management',
      icon: icons.NewCareers,
      url: accountsRoute.careerManagement,
    },
    {
      id: 13,
      title: 'Mentorship Management',
      icon: icons.NewMentorship,
      url: accountsRoute.mentorshipManagement,
    },
    {
      id: 14,
      title: 'Inbox/Notifications',
      icon: icons.NewInbox,
      url: accountsRoute.inboxNotifications,
    },
    {
      id: 15,
      title: 'Reports',
      icon: icons.NewInbox,
      url: accountsRoute.reports,
    },
    {
      id: 16,
      title: 'Branding Management',
      icon: icons.NewCertificate,
      url: accountsRoute.brandingManagement,
    },
    {
      id: 17,
      title: 'University Management',
      icon: icons.NewConferences,
      url: accountsRoute.universityManagement,
    },
    {
      id: 18,
      title: 'Institution Management',
      icon: icons.NewConferences,
      url: accountsRoute.institutionManagement,
    },
    {
      id: 19,
      title: 'Region Management',
      icon: icons.NewGroups,
      url: accountsRoute.regionManagement,
    },
    {
      id: 20,
      title: 'Department Management',
      icon: icons.NewGroups,
      url: accountsRoute.departmentManagement,
    },
    {
      id: 21,
      title: 'Settings',
      icon: icons.NewCareers,
      url: accountsRoute.setting,
    },
    {
      id: 22,
      title: 'Newsletter',
      icon: icons.NewGroups,
      url: accountsRoute.newsLetter,
    },
  ];

  const filteredAccountsSidebarOptions = accountsSidebarOptions.filter(
    (option) => {
      if (option.title === 'Dashboard') {
        return true;
      }
      const permission = userDetails?.role_data?.find(
        (item) => item.permission_name === option.title,
      );
      return permission?.sub_permission?.view === '1';
    },
  );

  const superAdminSidebarOptions = [
    {
      id: 1,
      title: 'Dashboard',
      icon: icons.NewDashboard,
      url: superAdminRoute.dashboard,
    },

    {
      id: 2,
      title: 'Profile Management',
      icon: icons.NewProfile,
      url: superAdminRoute.profileManagement,
    },
    {
      id: 3,
      title: 'Event Management',
      icon: icons.NewConferences,
      url: superAdminRoute.eventManagement,
    },
    {
      id: 4,
      title: 'Request Received',
      icon: icons.NewRaisedRequestIcon,
      url: superAdminRoute.requestReceived,
    },
    // {
    //   id: 5,
    //   title: 'Segment',
    //   icon: icons.NewConferences,
    //   url: superAdminRoute.segmentManagement,
    // },
    {
      id: 7,
      title: 'Tracking',
      icon: icons.NewRaisedRequestIcon,
      url: superAdminRoute.tracking,
    },
    {
      id: 8,
      title: 'Journal Management',
      icon: icons.NewPublications,
      url: superAdminRoute.journalManagement,
    },
    {
      id: 9,
      title: 'Network Management',
      icon: icons.NewNetworks,
      url: superAdminRoute.networkManagement,
    },
    {
      id: 10,
      title: 'Chapters & Groups Management',
      icon: icons.NewGroups,
      url: superAdminRoute.chaptersAndGroups,
    },
    {
      id: 11,
      title: 'Certificate Management',
      icon: icons.NewCertificate,
      url: superAdminRoute.certificateManagement,
    },
    {
      id: 12,
      title: 'Award Management',
      icon: icons.NewNomiAward,
      url: superAdminRoute.awardManagement,
    },
    {
      id: 13,
      title: 'Resource Management',
      icon: icons.NewGroups,
      url: superAdminRoute.resourceManagement,
    },
    {
      id: 14,
      title: 'Account Management',
      icon: icons.NewGroups,
      url: superAdminRoute.accountManagement,
    },
    {
      id: 15,
      title: 'Payment Verification',
      icon: icons.NewGroups,
      url: superAdminRoute.paymentVerification,
    },

    {
      id: 16,
      title: 'Career Management',
      icon: icons.NewCareers,
      url: superAdminRoute.careerManagement,
    },
    {
      id: 17,
      title: 'Mentorship Management',
      icon: icons.NewMentorship,
      url: superAdminRoute.mentorshipManagement,
    },
    {
      id: 18,
      title: 'Inbox/Notifications',
      icon: icons.NewInbox,
      url: superAdminRoute.inboxNotifications,
    },
    {
      id: 19,
      title: 'Reports',
      icon: icons.NewInbox,
      url: superAdminRoute.reports,
    },
    {
      id: 20,
      title: 'Branding Management',
      icon: icons.NewCertificate,
      url: superAdminRoute.brandingManagement,
    },
    {
      id: 21,
      title: 'University Management',
      icon: icons.NewConferences,
      url: superAdminRoute.universityManagement,
    },
    {
      id: 22,
      title: 'Institution Management',
      icon: icons.NewConferences,
      url: superAdminRoute.institutionManagement,
    },
    {
      id: 23,
      title: 'Region Management',
      icon: icons.NewGroups,
      url: superAdminRoute.regionManagement,
    },
    {
      id: 24,
      title: 'Department Management',
      icon: icons.NewGroups,
      url: superAdminRoute.departmentManagement,
    },
    {
      id: 25,
      title: 'Settings',
      icon: icons.NewCareers,
      url: superAdminRoute.setting,
    },
    {
      id: 26,
      title: 'Newsletter',
      icon: icons.NewGroups,
      url: superAdminRoute.newsLetter,
    },
    {
      id: 27,
      title: 'Instant Ticket Generate',
      icon: icons.QRScanner,
      url: superAdminRoute.instantTicketGenerate,
    },
    {
      id: 29,
      title: 'Email Templates',
      icon: icons.Email,
      url: superAdminRoute.emailTemplates,
    },
    // {
    //   id: 28,
    //   title: "User Activity Management",
    //   icon: icons.NewProfile,
    //   url: adminRoute.userActivityManagement,
    // },
  ];

  const userData = getDataFromLocalStorage();
  // const [IsShow , setIsShow] = useState(false);
  const { user_type, membership_details = {}, resource_role } = userData;
  const { id: membershipID } = membership_details;
  let navigate = useNavigate();
  const { tourIndex, isTour, isCollapseSidebar } = useSelector((state) => ({
    tourIndex: state.global.tourIndex,
    isTour: state.global.isTour,
    isCollapseSidebar: state.global.isCollapseSidebar,
  }));
  let { mentor_status } = getDataFromLocalStorage();
  const handleRedirect = (url) => {
    // IFERP Digital Library: open researchpedia login page in new tab (with SSO token for auto-login when available)
    if (url && url.includes('digital-library')) {
      const email = getDataFromLocalStorage('email_id');
      const base = RESEARCHPEDIA_BASE_URL.replace(/\/$/, '');

      const navData = {
        token: getDataFromLocalStorage('token'),
        data: 'insjhon@yopmail.com',
      };

      const encStr = encodeURIComponent(encrypt(navData));
      const researchpediaUrl = encStr
        ? `${base}/login?sso_token=${encStr}`
        : `${base}/login`;

      window.open(researchpediaUrl, '_blank', 'noopener,noreferrer');
      return;
    }
    navigate(url);
  };

  const getOptions = (type) => {
    let options = [];

    switch (type) {
      case '0':
        options = filteredAdminSidebarOptions;
        break;
      case '1':
        options = superAdminSidebarOptions;
        break;
      case '2':
        let newProfetionalSidebarOptions = [...profetionalSidebarOptions];
        if (!userData?.is_reviewer) {
          newProfetionalSidebarOptions = newProfetionalSidebarOptions.filter(
            (option) => option?.id !== 15,
          );
        }
        options = newProfetionalSidebarOptions;
        break;
      case '3':
        options = instituteSidebarOptions;
        break;
      case '4':
        options = corporateSidebarOptions;
        break;
      case '5':
        options = studentSidebarOptions;
        break;
      case '6':
        options = filtereCoOrdinatorResourceSidebarOptions;
        break;
      case '7':
        options = filteredAccountsSidebarOptions;
        break;
      default:
        options = [];
    }

    // 🔐 Apply Digital Library restriction here
    return filterDigitalLibraryAccess(options);
  };

  useEffect(() => {
    let elem = document.getElementById('side-option-list-id');
    if (tourIndex < 12 && isTour) {
      if (elem) {
        elem.style.overflowY = 'hidden';
      }
    } else {
      if (elem) {
        elem.style.overflowY = 'auto';
      }
    }
  }, [tourIndex, isTour]);

  const access = {
    isHelpAndSupport: membershipID === 3 || membershipID === 12,
    isSubMentorship: membershipID === 3 || membershipID === 2,
  };
  const loadOption = getOptions(user_type);
  const memberType = getUserType();

  const requestReceivedFilteredMenu = requestReceivedSubMenu.filter(
    (menuItem) => menuItem.userAccess?.includes(user_type),
  );

  const raisedRequestFilteredMenu = raisedRequestSubMenu.filter((menuItem) =>
    menuItem.userAccess?.includes(user_type),
  );

  const trackingFilteredMenu = trackingSubMenu.filter((menuItem) =>
    menuItem.userAccess?.includes(user_type),
  );

  const notificationFilteredMenu = notificationSubMenu.filter((menuItem) =>
    menuItem.userAccess?.includes(user_type),
  );
  const getHeightClass = (menuItems) => {
    const count = menuItems?.reduce((total, item) => {
      return total + 1 + (item.subItems ? item.subItems.length : 0);
    }, 0);

    return `cmb-${count * 40}`;
  };

  return (
    <div
      id="Sidebar-container"
      className={`iferp-scroll ${isCollapseSidebar ? 'collapse-side' : ''}`}
    >
      {/* <div className={`mobile-logo-container ${IsShow ? 'showslider' : 'hideSlider'}`} onClick={() => setIsShow(!IsShow)}> */}
      <div
        className={`mobile-logo-container`}
        onClick={() => {
          if (window.innerWidth > 1088) {
            dispatch(setIsCollapseSidebar(false));
          }
        }}
      >
        {/* <img className="img-logo1" src={icons.roundLogo} alt="img" /> */}
        <i className="bi bi-list img-logo1 text-24-500" />
      </div>

      <nav
        className={`sidemenu-container ${
          isCollapseSidebar ? 'collapse-sidemenu-container' : ''
        }`}
        id="nav-sidemenu"
      >
        <div className="desktop-logo-container">
          <div>
            <img className="img-logo1" src={icons.logo} alt="img" />
          </div>
          <div
            className="expand-icon"
            onClick={() => {
              dispatch(setIsCollapseSidebar(true));
            }}
          >
            <img src={icons.NewMenu} alt="collapse" />
          </div>
        </div>
        <ul className="iferp-scroll px-2" id="side-option-list-id">
          {loadOption?.map((elem) => {
            let isActive = window.location?.pathname?.includes(elem.url);
            const isHelp =
              window.location.pathname.includes('help') &&
              access.isHelpAndSupport;

            const isMentorship =
              window.location.pathname.includes('mentorship') &&
              access.isSubMentorship;

            const isReports = window.location.pathname.includes('/reports');
            const isRaisedRequest =
              window.location.pathname.includes('/raised-request');
            const isRequestReceived =
              window.location.pathname.includes('/request-received');
            const isTracking = window.location.pathname.includes('/tracking');
            const isNotification = window.location.pathname.includes(
              '/inbox-notifications',
            );

            if (isHelp && elem.url.includes('help')) {
              isActive = true;
            }
            if (isMentorship && elem.url.includes('mentorship')) {
              isActive = true;
            }
            if (isReports && elem?.url?.includes('reports')) {
              isActive = true;
            }
            if (isRaisedRequest && elem?.url?.includes('raised-request')) {
              isActive = true;
            }
            if (isRequestReceived && elem?.url?.includes('request-received')) {
              isActive = true;
            }
            if (isTracking && elem?.url?.includes('tracking')) {
              isActive = true;
            }
            if (
              window.location?.pathname?.includes('our-academicians') &&
              elem?.url?.includes('our-academicians')
            ) {
              isActive = true;
            }
            const pathname = window.location?.pathname || '';
            const redirectBasePaths = [
              'activity-plan',
              'conferences-and-events',
              'events',
              'publications',
              'inbox-notifications',
              'network-management',
              'innovation-ambassador',
              'chapters-groups',
              'career-support',
              'funds-and-grants',
              'my-profile',
            ];
            if (
              redirectBasePaths.some(
                (base) => pathname.includes(base) && elem?.url?.includes(base),
              )
            ) {
              isActive = true;
            }

            return (
              <li
                key={elem.id}
                id={elem.tourId || ''}
                className={`sidemenu-block ${
                  isActive
                    ? `${
                        isMentorship &&
                        mentor_status !== 'Reject' &&
                        mentor_status !== ''
                          ? 'cmb-130'
                          : ''
                      }
                    ${isMentorship && 'cmb-60'}
                    ${isReports && 'cmb-250'}
                      } 
                    ${
                      isRaisedRequest &&
                      getHeightClass(raisedRequestFilteredMenu)
                    }
                    ${
                      isRequestReceived &&
                      getHeightClass(requestReceivedFilteredMenu)
                    }
                    ${isTracking && getHeightClass(trackingFilteredMenu)}
                     ${
                       isNotification &&
                       getHeightClass(notificationFilteredMenu)
                     }
                     active-option pointer 
                    `
                    : 'color-black-olive pointer'
                }`}
                onClick={() => {
                  if (elem.url) {
                    handleRedirect(elem.url);
                  }
                }}
              >
                <div className="sidemenu-block">
                  <img
                    src={elem.icon}
                    alt={elem.title}
                    height={20}
                    width={20}
                  />
                  <em>{elem.title}</em>
                  {!isCollapseSidebar && elem?.isNewFeature && !isActive && (
                    <span className="new-feature-logo-block text-12-500">
                      New
                    </span>
                  )}

                  {isHelp && isActive && (
                    <i className="bi bi-chevron-down help-colaps-icon" />
                  )}
                  {isMentorship && isActive && (
                    <i className="bi bi-chevron-down help-colaps-icon" />
                  )}
                  {isReports && isActive && (
                    <i className="bi bi-chevron-down help-colaps-icon" />
                  )}

                  {isRaisedRequest && isActive && (
                    <i className="bi bi-chevron-down help-colaps-icon" />
                  )}
                  {isRequestReceived && isActive && (
                    <i className="bi bi-chevron-down help-colaps-icon" />
                  )}
                  {isTracking && isActive && (
                    <i className="bi bi-chevron-down help-colaps-icon" />
                  )}
                </div>
                {isHelp && isActive && (
                  <div className="help-and-support">
                    <div className="help-option-block mt-3">
                      <div className="hr-line" />
                      <div className="vr-line" />
                      <div
                        className={`help-option w-100 text-14-500-18  pointer ${
                          window.location.pathname.includes('help-and-support')
                            ? 'active-sub'
                            : 'inactive-sub'
                        }`}
                        onClick={() => {
                          navigate(
                            `/${params?.memberType}/help/help-and-support`,
                          );
                        }}
                      >
                        Help & Support
                      </div>
                    </div>
                    <div className="help-option-block mt-3">
                      <div className="hr-line" />
                      <div className="vr-line" />
                      <div
                        className={`help-option w-100 text-14-500-18  pointer ${
                          window.location.pathname.includes(
                            'my-personal-executive',
                          )
                            ? 'active-sub'
                            : 'inactive-sub'
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          navigate(
                            `/${params?.memberType}/help/my-personal-executive`,
                          );
                        }}
                      >
                        My Personal Executive
                      </div>
                    </div>
                  </div>
                )}
                {isHelp && isActive && (
                  <div className="mobile-help-and-support">
                    <div className="help-option-block mt-3">
                      <div
                        className={`text-22-400 ${
                          window.location.pathname.includes('help-and-support')
                            ? 'color-new-car'
                            : 'color-black-olive'
                        }`}
                      >
                        <i className="bi bi-headset" />
                      </div>
                      <div
                        className={`help-option w-100 text-14-500-18  pointer ${
                          window.location.pathname.includes('help-and-support')
                            ? 'active-sub'
                            : 'inactive-sub'
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          navigate(
                            `/${params?.memberType}/help/help-and-support`,
                          );
                        }}
                      >
                        Help & Support
                      </div>
                    </div>
                    <div className="help-option-block mt-3">
                      <div
                        className={` text-22-400 ${
                          window.location.pathname.includes(
                            'my-personal-executive',
                          )
                            ? 'color-new-car'
                            : 'color-black-olive'
                        }`}
                      >
                        <i className="bi bi-chat-left-dots" />
                      </div>
                      <div
                        className={`help-option w-100 text-14-500-18  pointer ${
                          window.location.pathname.includes(
                            'my-personal-executive',
                          )
                            ? 'active-sub'
                            : 'inactive-sub'
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          navigate(
                            `/${params?.memberType}/help/my-personal-executive`,
                          );
                        }}
                      >
                        My Personal Executive
                      </div>
                    </div>
                  </div>
                )}

                {isMentorship && isActive && (
                  <div className="sub-mentorship">
                    <div className="mentorship-option-block mt-3">
                      <div className="hr-line" />
                      <div className="vr-line" />
                      <div
                        className={`mentorship-option w-100 text-14-500-18  pointer ${
                          window.location.pathname.includes('mentee')
                            ? 'active-sub'
                            : 'inactive-sub'
                        }`}
                        onClick={() => {
                          navigate(
                            `/${params?.memberType}/mentorship/mentee/all-mentors`,
                          );
                        }}
                      >
                        Mentee Profile
                      </div>
                    </div>
                    {mentor_status !== 'Reject' && mentor_status !== '' && (
                      <div className="mentorship-option-block mt-3">
                        <div className="hr-line" />
                        <div className="vr-line" />
                        <div
                          className={`mentorship-option w-100 text-14-500-18  pointer ${
                            window.location.pathname
                              ?.split('/')
                              .includes('mentor')
                              ? 'active-sub'
                              : 'inactive-sub'
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            navigate(
                              `/${params?.memberType}/mentorship/mentor`,
                            );
                          }}
                        >
                          Mentor Profile
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {isMentorship && isActive && (
                  <div className="mobile-sub-mentorship">
                    <div className="mentorship-option-block mt-3">
                      <div
                        className={`text-22-400 ${
                          window.location.pathname.includes('mentee')
                            ? 'color-new-car'
                            : 'color-black-olive'
                        }`}
                      >
                        <i className="bi bi-people-fill" />
                      </div>
                      <div
                        className={`mentorship-option w-100 text-14-500-18 pointer ${
                          window.location.pathname.includes('mentee')
                            ? 'active-sub'
                            : 'inactive-sub'
                        }`}
                        onClick={() => {
                          navigate(
                            `/${params?.memberType}/mentorship/mentee/all-mentors`,
                          );
                        }}
                      >
                        Mentee
                      </div>
                    </div>
                    <div className="mentorship-option-block mt-3">
                      <div
                        className={`text-22-400 ${
                          window.location.pathname
                            ?.split('/')
                            .includes('mentor')
                            ? 'color-new-car'
                            : 'color-black-olive'
                        }`}
                      >
                        <i className="bi bi-person-square" />
                      </div>
                      <div
                        className={`mentorship-option w-100 text-14-500-18 pointer ${
                          window.location.pathname
                            ?.split('/')
                            .includes('mentor')
                            ? 'active-sub'
                            : 'inactive-sub'
                        }`}
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          navigate(`/${params?.memberType}/mentorship/mentor`);
                        }}
                      >
                        Mentor
                      </div>
                    </div>
                  </div>
                )}

                {isReports && isActive && (
                  <div className="sub-reports-menu">
                    {reportSubMenu.map((subMenu, index) => {
                      const { label, type } = subMenu;
                      return (
                        <div className="reports-option-block mt-3" key={index}>
                          <div className="hr-line" />
                          <div className="vr-line" />
                          <div
                            className={`reports-option w-100 text-14-500-18 pointer ${
                              window.location.pathname.includes(`${type}`)
                                ? 'active-sub'
                                : 'inactive-sub'
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              navigate(`${elem?.url}/${type}`);
                            }}
                          >
                            {label}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
                {isReports && isActive && (
                  <div className="mobile-sub-reports-menu">
                    {reportSubMenu.map((subMenu, index) => {
                      const { label, type, icon } = subMenu;
                      return (
                        <div className="reports-option-block mt-3" key={index}>
                          <div
                            className={`text-22-400 ${
                              window.location.pathname.includes(`${type}`)
                                ? 'color-new-car'
                                : 'color-black-olive'
                            }`}
                          >
                            <i
                              className={`${icon} ${
                                window.location.pathname.includes(`${type}`)
                                  ? 'color-new-car'
                                  : ''
                              }`}
                            />
                          </div>
                          <div
                            className={`reports-option w-100 text-14-500-18 pointer ${
                              window.location.pathname.includes(`${type}`)
                                ? 'active-sub'
                                : 'inactive-sub'
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              navigate(`${elem?.url}/${type}`);
                            }}
                          >
                            {label}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}

                {isRaisedRequest && isActive && (
                  <div className="sub-menu">
                    {raisedRequestFilteredMenu?.map((menuItem) => (
                      <div
                        key={menuItem.id}
                        className={`reports-option-block mt-2 ${
                          menuItem.subItems ? 'column-direction' : ''
                        }`}
                      >
                        <div
                          className={`reports-option w-100 text-14-500-18 pointer ${
                            window.location.pathname.includes(menuItem.type) ||
                            (menuItem.subItems &&
                              menuItem.subItems.some((sub) =>
                                window.location.pathname.includes(sub.type),
                              ))
                              ? 'active-sub'
                              : 'inactive-sub'
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (!menuItem.subItems) {
                              navigate(
                                `/${memberType}/raised-request/${menuItem.type}`,
                              );
                            }
                          }}
                        >
                          {menuItem.icon && (
                            <i className={`${menuItem.icon} mr-2`} />
                          )}
                          {menuItem.label}

                          {/* Always show down arrow if subItems exist */}
                          {/* {menuItem.subItems && (
                            <i className="bi bi-chevron-down ml-2" />
                          )} */}
                        </div>

                        {/* Always render nested submenu if it exists */}
                        {menuItem.subItems && (
                          <div className="nested-sub-menu pl-3">
                            {menuItem.subItems.map((subItem) => (
                              <div
                                key={subItem.id}
                                className={`reports-option w-100 text-14-500-18 pointer mt-2 ${
                                  window.location.pathname.includes(
                                    subItem.type,
                                  )
                                    ? 'active-sub'
                                    : 'inactive-sub'
                                }`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(
                                    `/${memberType}/raised-request/${subItem.type}`,
                                  );
                                }}
                              >
                                {subItem.icon && (
                                  <i className={`${subItem.icon} mr-2`} />
                                )}
                                {subItem.label}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {isRequestReceived && isActive && (
                  <div className="sub-menu">
                    {requestReceivedFilteredMenu.map((menuItem) => (
                      <div
                        key={menuItem.id}
                        className={`reports-option-block mt-2 ${
                          menuItem.subItems ? 'column-direction' : ''
                        }`}
                      >
                        <div
                          className={`reports-option w-100 text-14-500-18 pointer ${
                            window.location.pathname.includes(menuItem.type) ||
                            (menuItem.subItems &&
                              menuItem.subItems.some((sub) =>
                                window.location.pathname.includes(sub.type),
                              ))
                              ? 'active-sub'
                              : 'inactive-sub'
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            // if (!menuItem.subItems) {
                            navigate(
                              `/${memberType}/request-received/${menuItem.type}`,
                            );
                            // }
                          }}
                        >
                          {menuItem.icon && (
                            <i className={`${menuItem.icon} mr-2`} />
                          )}
                          {menuItem.label}

                          {/* Always show down arrow if subItems exist */}
                          {/* {menuItem.subItems && (
                            <i className="bi bi-chevron-down ml-2" />
                          )} */}
                        </div>

                        {/* Always render nested submenu if it exists */}
                        {menuItem.subItems && (
                          <div className="nested-sub-menu pl-3">
                            {menuItem.subItems.map((subItem) => (
                              <div
                                key={subItem.id}
                                className={`reports-option w-100 text-14-500-18 pointer mt-2 ${
                                  window.location.pathname.includes(
                                    subItem.type,
                                  )
                                    ? 'active-sub'
                                    : 'inactive-sub'
                                }`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate(
                                    `/${memberType}/request-received/${subItem.type}`,
                                  );
                                }}
                              >
                                {subItem.icon && (
                                  <i className={`${subItem.icon} mr-2`} />
                                )}
                                {subItem.label}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}

                {isTracking && isActive && (
                  <div className="sub-menu">
                    {trackingFilteredMenu.map((menuItem) => (
                      <div
                        key={menuItem.id}
                        className={`reports-option-block mt-2 ${
                          menuItem.subItems ? 'column-direction' : ''
                        }`}
                      >
                        <div
                          className={`reports-option w-100 text-14-500-18 pointer ${
                            window.location.pathname.includes(menuItem.type) ||
                            (menuItem.subItems &&
                              menuItem.subItems.some((sub) =>
                                window.location.pathname.includes(sub.type),
                              ))
                              ? 'active-sub'
                              : 'inactive-sub'
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(
                              `/${memberType}/tracking/${menuItem.type}`,
                            );
                          }}
                        >
                          {menuItem.icon && (
                            <i className={`${menuItem.icon} mr-2`} />
                          )}
                          {menuItem.label}
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {isNotification && isActive && (
                  <div className="sub-menu">
                    {notificationFilteredMenu?.map((menuItem) => (
                      <div
                        key={menuItem.id}
                        className={`reports-option-block mt-2 ${
                          menuItem.subItems ? 'column-direction' : ''
                        }`}
                      >
                        <div
                          className={`reports-option w-100 text-14-500-18 pointer ${
                            window.location.pathname.includes(menuItem.type) ||
                            (menuItem.subItems &&
                              menuItem.subItems.some((sub) =>
                                window.location.pathname.includes(sub.type),
                              ))
                              ? 'active-sub'
                              : 'inactive-sub'
                          }`}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigate(
                              `/${memberType}/inbox-notifications/${menuItem.type}`,
                            );
                          }}
                        >
                          {menuItem.icon && (
                            <i className={`${menuItem.icon} mr-2`} />
                          )}
                          {menuItem.label}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </li>
            );
          })}

          <li
            className={`sidemenu-block pointer ${
              window.location.pathname.includes('help') &&
              access.isHelpAndSupport
                ? 'cmt-125 logout-options'
                : ''
            }`}
            onClick={() => {
              dispatch(setIsLogout(true));
            }}
          >
            <div className="sidemenu-block text-14-500-18 color-black-olive pointer">
              <img src={icons.NewLogout} alt="logout" />
              <em>Log Out</em>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  );
};
export default Sidebar;

//  <div className="sub-menu">
//                     {raisedRequestSubMenu.map((subMenu, index) => {
//                       const { label, type } = subMenu;
//                       return (
//                         <div className="reports-option-block mt-2" key={index}>
//                           {/* <div className="hr-line" /> */}
//                           {/* <div className="vr-line" /> */}
//                           <div
//                             className={`reports-option w-100 text-14-500-18 pointer ${
//                               window.location.pathname.includes(`${type}`)
//                                 ? 'active-sub'
//                                 : 'inactive-sub'
//                             }`}
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               navigate(
//                                 `/${memberType}/${
//                                   isRaisedRequest
//                                     ? 'raised-request'
//                                     : 'request-received'
//                                 }/${type}`
//                               );
//                             }}
//                           >
//                             {label}
//                           </div>
//                         </div>
//                       );
//                     })}
//                   </div>
